type Props = {
	color: string;
};

export default function Footer({ color }: Props) {
	// Computed during render, not in an effect: deferring it to useEffect means the
	// prerendered HTML says "© 2026" while the client's first render says "©",
	// and that text mismatch fails hydration for the whole tree.
	const year = new Date().getUTCFullYear();

	return (
		<footer>
			<div
				className={`h-fit w-full text-white tracking-wide font-light text-md uppercase flex pt-5 pb-2`}
				style={{ backgroundColor: color }}>
				<div className="mt-auto mx-auto footer--copy w-[50%] text-center">
					&copy; {year} Ph4sm4 Solutions | Olaf Dalach
				</div>
			</div>
		</footer>
	);
}
